import Header from "../pages/header";
import Footer from "../pages/Footer";
import {Outlet} from "react-router-dom";

const DefaultLayout = () => {

    return (
        <>
            <Header/>
                <main>
                    <Outlet />
                </main>
            <Footer />
        </>
    );
}

export default DefaultLayout;